import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteField, deleteMultipleFields } from "services";

import {
  DELETE_FIELD,
  DELETE_MULTIPLE_FIELDS,
  GET_FARMS,
  GET_FARM_FIELD_LIST_AT_POINT_IN_TIME,
  GET_FARM_RESILIENCE_SCORE,
  GET_FIELDS,
  GET_FIELD_PRACTICE_FILTER_OPTIONS,
} from "consts";

export const useDeleteField = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_FIELD],
    mutationFn: deleteField,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_PRACTICE_FILTER_OPTIONS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_FIELD_LIST_AT_POINT_IN_TIME] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_RESILIENCE_SCORE] });
    },
  });
};

export const useDeleteMultipleFields = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_MULTIPLE_FIELDS],
    mutationFn: deleteMultipleFields,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_PRACTICE_FILTER_OPTIONS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_FIELD_LIST_AT_POINT_IN_TIME] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_RESILIENCE_SCORE] });
    },
  });
};
